import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropdocsModal from '../../../modal/PropdocsModal';
interface SendDocumentForSigningProps {
  onHide: () => void;
  show: boolean;
  onConfirm: () => void;
  isLoading: boolean;
  additionalMessageInputRef: React.Ref<HTMLTextAreaElement>;
}

const SendDocumentForSigning = ({
  onHide,
  show,
  onConfirm,
  isLoading,
  additionalMessageInputRef,
}: SendDocumentForSigningProps) => {
  return (
    <PropdocsModal
      size="lg"
      show={show}
      setShow={onHide}
      title={<FormattedMessage id="document-wizard-modal.send-for-signing" defaultMessage="Send for Signing" />}
    >
      <div style={{ padding: '0 0 2rem 0' }}>
        <div style={{ marginBottom: '1.5rem' }}>
          Access for all users will become read-only when this document is sent for signing. All signer emails provided
          will be notified to review and sign the document.
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label htmlFor="signerMessage" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>
            Optional message for signers
          </label>
          <textarea
            id="signerMessage"
            ref={additionalMessageInputRef}
            className="form-control"
            rows={3}
            placeholder="Add a message that will be included in the signature request email (optional)"
            style={{ width: '100%', resize: 'vertical' }}
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', paddingTop: '1.5rem' }}>
          <button type="button" className="btn btn-outline-secondary" onClick={onHide}>
            Cancel
          </button>
          <button type="button" className="btn btn-secondary" onClick={onConfirm} disabled={isLoading}>
            {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
            Send
          </button>
        </div>
      </div>
    </PropdocsModal>
  );
};

export default SendDocumentForSigning;
